var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.817 10.2827C25.4754 10.6327 26.0261 11.1552 26.4102 11.7942C26.7942 12.4332 26.9971 13.1646 26.9971 13.9101C26.9971 14.6555 26.7942 15.387 26.4102 16.026C26.0261 16.6649 25.4754 17.1874 24.817 17.5375L7.25387 27.0848C4.42584 28.6237 0.952148 26.623 0.952148 23.4588V4.36272C0.952148 1.19716 4.42584 -0.802208 7.25387 0.733977L24.817 10.2827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.7ff3d1ed051f881389818a406a2e5d7b.svg";
export { ForwardRef as ReactComponent };